import { FormControl, FormGroup } from '@angular/forms';
import { BorrowerApi } from '@sg/api/borrower-api';
import { LoanAction } from './loan-action';

type LocateMatchForm = {
  units: FormControl<number>;
  rate: FormControl<number>;
  settlementDate: FormControl<BorrowerApi.KeyDatesDto>;
};

export enum CollateralTypeEnum {
  NONCASH = 'NONCASH',
  CASH = 'CASH',
  CASH_AND_NONCASH = 'CASH_AND_NONCASH',
}
export type CollateralTypeDto = keyof typeof CollateralTypeEnum;

export type CollateralSpecificMatch = {
  type?: CollateralTypeDto;
  selectedLegalEntity?: BorrowerApi.AvailabilitySplitDto;
  requestedLowerRate?: boolean;
  unitsUpdated?: boolean;
  unitsRequestedQtyOverAvailable?: boolean;
  unitsRequestedValueBelowMin?: boolean;
  matchUnits?: Array<BorrowerApi.AvailabilitySplitDto>;
  form?: FormGroup<LocateMatchForm>;
};

export type LocateMatch = BorrowerApi.LocateMatchDto & {
  cashMatch?: CollateralSpecificMatch;
  nonCashMatch?: CollateralSpecificMatch;
  sharedUnits?: number;
};

export type LegalEntitySelectionChangeEvent = {
  collateralSpecificMatch: CollateralSpecificMatch;
  selectedLegalEntity: BorrowerApi.AvailabilitySplitDto;
};

export type ActionClickEvent = {
  collateralSpecificMatch: CollateralSpecificMatch;
  action: LoanAction;
};

export type AfterBookingActionData = {
  bbgid: string;
  collateralType: CollateralTypeDto;
};

export type CollateralTypesToDisplay = {
  cash: boolean;
  nonCash: boolean;
};
